/**
 * Created by Sasha on 7/25/2018.
 */
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
@Injectable()
export class EventTypeService  {
  eventTypes: any[];
  onEventTypeChanged: BehaviorSubject<any> = new BehaviorSubject({});
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getEventTypes()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getEventTypes () {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/eventType/eventTypes'  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.eventTypes = response;
          this.onEventTypeChanged.next(this.eventTypes);
          resolve(response);
        }, reject);
    });

  }

  getEventById(id) {
    return this.http.get(this.api.baseUrl + '/eventType/eventType?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteEventType(id) {
    return this.http.delete(this.api.baseUrl + '/eventType/deleteEventType?id=' + id , this.api.jsonTokenHeaders);
  }

  addEventType(data) {
    return this.http.post(this.api.baseUrl + '/eventType/addEvent' , data , this.api.formDataHeaders);
  }

  getEventTypeDropDown() {
    return this.http.get(this.api.baseUrl + '/eventType/eventTypes'  , this.api.jsonTokenHeaders);
  }
}
